export default {
  pickup: 'Pickup',
  delivery: 'Delivery',
};
